// Define the Hook with the IconProps type as an argument

import { useAnimation, useInView } from "framer-motion";
import { useEffect } from "react";


const useLeftReviewScrollAnimation = (ref: React.RefObject<HTMLDivElement>) => {

    const boxVariant = {
        visible: { opacity: 1, translateX: 0, transition: { duration: 0.2 } },
        hidden: { opacity: 0, translateX: -30 }
    };

    const control = useAnimation();
    const inView = useInView(ref, { once: true, amount: 0.8});

    useEffect(() => {
        if (inView) {
            control.start("visible");
        } else {
            control.start("hidden");
        }
    }, [inView, control])

    return {
        ref,
        control,
        variants: boxVariant,
        initial: "hidden"
    }
}
export default useLeftReviewScrollAnimation;